import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

export type RouterLinkButtonProps = Pick<LinkProps, 'to'> & Omit<ButtonProps, 'component'>;

export const RouterLinkButton: React.FC<RouterLinkButtonProps> = ({ children, to, sx, ...props }) => {
  const buttonProps = {
    ...props,
    sx,
    to,
    component: RouterLink,
  };
  return <Button {...buttonProps}>{children}</Button>;
};
